var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66406 3.33268C1.66406 2.41221 2.41025 1.66602 3.33073 1.66602H16.6641C17.5845 1.66602 18.3307 2.41221 18.3307 3.33268V4.01394C18.3307 4.64717 18.0904 5.25681 17.6584 5.71974L12.9456 10.7691C12.6576 11.0777 12.4974 11.4841 12.4974 11.9063V15.3177C12.4974 15.6333 12.3191 15.9218 12.0367 16.063L8.70341 17.7297C8.14932 18.0067 7.4974 17.6038 7.4974 16.9843V11.9063C7.4974 11.4841 7.3372 11.0777 7.04915 10.7691L2.33642 5.71974C1.90436 5.25681 1.66406 4.64717 1.66406 4.01394V3.33268Z",
    fill: "#924D27",
    stroke: "#924D27",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterColor);
export default __webpack_public_path__ + "static/media/filter-color.ebf1ac21e71c68b478d9b58501546476.svg";
export { ForwardRef as ReactComponent };